
import React from 'react';
import classNames from 'classnames';
import NoImpulseFound from './no-impulse-found';

export const ContentWrapperWithEmptyState = ({landExists, isRefreshing, EmptyStateComponent = NoImpulseFound, ContentWrapperComponent = ContentWrapper, children}) => {
    if (!landExists) {
        return (
            <ContentWrapperComponent>
                <EmptyStateComponent/>
            </ContentWrapperComponent>
        )
    }
    return (
        <ContentWrapperComponent {...{isRefreshing}}>
            {children}
        </ContentWrapperComponent>
    )
}

const ContentWrapper = ({isRefreshing, children}) => {
    return (
        <div className='checkout-content block impulse'>
            <div className={classNames('checkout-view display-flex flex-direction-column checkout-view--container', {'opacity-0dot6': isRefreshing})}>
                {children}
            </div>
        </div>
    )
};

export default React.memo(ContentWrapper);
